import { Snackbar } from "@mui/material";
import React from "react";

import Alert from "./Alert";

interface CustomSnackbarProps {
    open: boolean;
    onClose: () => void;
    text: string;
    variant: "success" | "error" | "warning";
}
const CustomSnackbar: React.FunctionComponent<CustomSnackbarProps> = ({ open, onClose, text, variant }) => (
    <Snackbar open={open} autoHideDuration={6000} onClose={onClose}>
        <Alert onClose={onClose} severity={variant} sx={{ width: "100%" }}>
            {text}
        </Alert>
    </Snackbar>
);

export default CustomSnackbar;
